export const COLOR_BOMA_BLUE = "#0B3962";
export const COLOR_BTN_PRIMARY = "#51A6E2"; // BOMA Interior blue
export const COLOR_BTN_SECONDARY = "#D79027"; // BOMA shop orange
export const COLOR_BTN_TERNARY = "#00ADD0"; // BOMA Direct blue
export const COLOR_BTN_SHOPPING = "#5BAE8F";